import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext, UserContext } from 'commons-ui'; // Adjust the import path as necessary
import _get from 'lodash/get';
import { NA_VALUE } from 'constant';
import useService from '../../../useService';
import { Record } from '../../../helper';

type ScheduleData = {
	scheduleDate: number;
	scheduledAtTimestamp: number | typeof NA_VALUE;
	[key: string]: any;
};

type InitialData = {
	[key: string]: any;
};

const useSchedule = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { user } = useContext(UserContext);
	const { requestScheduleSegment } = useService();
	const initialData: InitialData = _get(location, ['state', 'rowData'], {});
	const today: Date = new Date();
	today.setHours(0, 0, 0, 0); // Set time to start of day
	const defaultData: ScheduleData = {
		...initialData,
		scheduleDate: today.getTime(), // Set to today's timestamp
		scheduledAtTimestamp: initialData.scheduledAtTimestamp || NA_VALUE // Set default if null or empty
	};
	const updateScheduleInfo = async (segmentData: Record): Promise<void> => {
		setShowLoader(true);
		try {
			const scheduleData: Record = { ...segmentData };
			if (!scheduleData.date) {
				scheduleData.date = new Date().setHours(0, 0, 0, 0); // Set default date to today
			}
			// Clean up unnecessary fields
			if (_get(scheduleData, 'id')) {
				delete scheduleData.id;
			}
			if (_get(scheduleData, 'index')) {
				delete scheduleData.index;
			}
			const response: boolean = await requestScheduleSegment(scheduleData, showAlert, user);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};
	const handleFormSubmit = (submittedData: Record): void => {
		updateScheduleInfo(submittedData);
	};
	const handleFormCancel = (): void => {
		history.goBack();
	};
	return {
		data: defaultData,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};
export default useSchedule;
